import { useState } from "react";
import { boardSections } from "@/mocks/trending";

const tabs = [
  { key: "ent", label: "娱乐" },
  { key: "tech", label: "科技" },
  { key: "fin", label: "财经" },
  { key: "soc", label: "社会" },
];

const heatColor: Record<string, string> = {
  爆: "bg-primary-500 text-background-50",
  热: "bg-accent-500 text-background-50",
  新: "bg-secondary-600 text-background-50",
  议: "bg-background-300 text-foreground-800",
  暖: "bg-accent-400 text-background-50",
  景: "bg-secondary-500 text-background-50",
  学: "bg-primary-400 text-background-50",
};

export default function BoardFeed() {
  const [tab, setTab] = useState("ent");
  const list = boardSections[tab];

  return (
    <section className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h2 className="flex items-center gap-2 text-2xl md:text-3xl font-black text-foreground-950">
            <span className="w-9 h-9 flex items-center justify-center rounded-xl bg-secondary-600 text-background-50">
              <i className="ri-dashboard-3-line"></i>
            </span>
            板块热议速递
          </h2>
          <p className="mt-2 text-sm text-foreground-500">按板块分区，想看哪块点哪块，各自榜单随切随看。</p>
        </div>
      </div>

      {/* tabs */}
      <div className="mt-6 flex flex-wrap items-center gap-2">
        {tabs.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={`cursor-pointer whitespace-nowrap px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
              tab === t.key
                ? "bg-foreground-950 text-background-50"
                : "bg-background-100 text-foreground-600 border border-background-200 hover:text-primary-600"
            }`}
          >
            {t.label}
          </button>
        ))}
        <span className="ml-auto hidden md:inline text-xs text-foreground-400 whitespace-nowrap">
          共收录 {tabs.length} 大板块
        </span>
      </div>

      {/* 信息流 */}
      <div className="mt-6 flex flex-col gap-4">
        {list.map((item) => (
          <a
            key={item.id}
            href="#top"
            className="group flex flex-col sm:flex-row gap-4 rounded-2xl border border-background-200/80 bg-background-50 p-3 cursor-pointer hover:border-primary-200 hover:bg-background-50/70 transition-colors"
          >
            <div className="relative w-full sm:w-48 shrink-0 h-36 sm:h-28 overflow-hidden rounded-xl">
              <img
                src={item.cover}
                alt={item.title}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className={`absolute left-2 top-2 rounded-md px-2 py-0.5 text-[11px] font-bold ${heatColor[item.heat] || heatColor.热}`}>
                {item.heat}
              </span>
            </div>
            <div className="flex flex-1 flex-col min-w-0">
              <h3 className="text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="mt-1.5 text-sm text-foreground-500 leading-relaxed">{item.summary}</p>
              <div className="mt-auto pt-3 flex items-center gap-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-chat-3-line"></i>
                  </span>
                  {item.comments.toLocaleString()} 讨论
                </span>
                <span className="ml-auto flex items-center gap-1 whitespace-nowrap">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-time-line"></i>
                  </span>
                  {item.time}
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}